
import Vue from 'vue';

export default Vue.extend({
	name: 'RunnitModels',
	metaInfo: {
		titleTemplate: '%s | Models | Runnit | RunDiffusion',
	},
	computed: {},
	components: {},
	props: {},
	data () {
		return {};
	},
	methods: {}
});
